import { css } from 'lit';

export const q1MembershipListStyles = css`

  :host {
    display: block;
  }

  #base-container {
    position: relative;
    overflow: hidden;
    border: 1px solid var(--gray-2);
    border-radius: 7px;
  }

  query-bar {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 1rem;
    padding: 1rem;
    background: var(--gray-0);
    border-bottom: 1px solid var(--gray-2);
  }

  query-bar .spacer {
    flex: 1 1 auto;
  }

  query-bar .label {
    font-size: 0.9rem;
    color: var(--gray-6);
    font-weight: 300;
  }

  query-bar .input-set {
    display: flex;
    flex-wrap: nowrap;
    gap: 0.5rem;
    align-items: center;
  }

  a {
    color: var(--link-color-default, var(--blue-7));
    text-decoration: var(--link-text-decoration-default, underline);
    font-weight: var(--link-font-weight-default, normal);
    transition: all 0.2s ease-in-out;
  }
  a:visited {
    color: var(--link-color-visited, var(--blue-8));
  }
  a:focus, a:hover {
    color: var(--link-color-focus, var(--blue-9));
    font-weight: var(--link-font-weight-focus, var(--link-font-weight-default, normal));
    text-decoration: var(--link-text-decoration-focus, underline);
  }

  table-wrapper {
    display: block;
    overflow: auto;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    border: none;

    --table-edge-cell-padding: 1rem;
    --table-cell-padding: 0.5rem;
    --table-border: 1px solid var(--gray-2);
  }

  table th {
    text-align: left;
    font-size: 0.9rem;
    font-weight: 600;
    line-height: 2em;
    color: var(--gray-7);

    padding: var(--table-cell-padding);
    border-bottom: var(--table-border);
    background: var(--gray-0);
  }
  table th:first-child {
    padding-left: var(--table-edge-cell-padding);
  }
  table th:last-child {
    padding-right: var(--table-edge-cell-padding);
  }

  table td {
    font-size: 0.9rem;
    font-weight: 400;

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    padding: var(--table-cell-padding);
    background: var(--gray-0);
  }
  table td:first-child {
    padding-left: var(--table-edge-cell-padding);
  }
  table td:last-child {
    padding-right: var(--table-edge-cell-padding);
  }
  table tr:not(:last-child) td {
    border-bottom: var(--table-border);
  }

  td.role-col.proposed {
    font-style: italic;
    color: var(--gray-6);
    font-weight: 300;
  }

  tr.empty-placeholder td .td-inner {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    color: var(--gray-6);
    font-size: 1rem;
    line-height: 1.5em;
    font-weight: 300;
    font-style: italic;
    margin: 0.5rem 0;
  }

  /*=== LOAD MORE ===*/

  #load-more-container {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    padding: 1rem 0;
  }

  .not-signed-in-message {
    text-align: center;
    font-style: italic;
    color: var(--gray-7);
    padding: 1.5rem;
  }

`;
